<template>
  <div class="geogrid-competitor">
    <div class="geogrid-competitor__rank">
      <slot name="rank" />
    </div>
    <div class="geogrid-competitor__wrapper">
      <a
        class="geogrid-competitor__name"
        :href="competitor.placeId ? `https://www.google.com/maps/search/?api=1&query=1&query_place_id=${competitor.placeId}` : null"
        target="_blank"
        @click.stop>
        {{ competitor.name }}
      </a>
      <div class="geogrid-competitor__address">
        <template v-if="competitor.formattedAddress">
          {{ competitor.formattedAddress }}
        </template>
        <template v-else>
          Service Area Business
        </template>
      </div>
      <div class="geogrid-competitor__metrics">
        <div v-for="metric in metrics" :key="metric.name" class="geogrid-competitor__metric">
          <p>{{ metric.name }}</p>
          <span>{{ metric.value }}</span>
        </div>
      </div>
    </div>
    <div class="geogrid-competitor__preview">
      <GeogridPreview :ranks="competitor.geogrid.ranks" />
    </div>
  </div>
</template>
<script>

import GeogridPreview from '../../vue_widgets/geogrids/components/geogrid_preview.vue'

export default {
  components: {
    GeogridPreview
  },
  props: {
    competitor: {
      type: Object,
      required: true
    }
  },
  computed: {
    metrics() {
      const NA = 'N/A'
      const round = (num) => Math.round(num * 100) / 100
      const format = (num) => (num ? round(num) : NA)
      const fixValue = (value) => {
        const formattedValue = format(value)
        return formattedValue !== NA ? formattedValue.toFixed(2) : formattedValue
      }
      return [
        {
          name: 'AGR',
          value: fixValue(this.competitor.geogrid.agr)
        },
        {
          name: 'ATGR',
          value: fixValue(this.competitor.geogrid.atgr)
        },
        {
          name: 'SoLV',
          value: this.competitor.geogrid.solv ? `${(round(this.competitor.geogrid.solv) * 100).toFixed(0)}%` : '0%'
        }
      ]
    }
  }
}
</script>
